import { IMicrofrontendsAPI } from 'shared/common/types/microfrontends/types';

import { getDesktopFiltersMicrofrontendApi } from './internal/getDesktopFiltersMicrofrontendApi';
import { getHeaderMicrofrontendApi } from './internal/getHeaderMicrofrontendApi';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: getHeaderMicrofrontendApi(),
    filters: getDesktopFiltersMicrofrontendApi(),
  };
}
